// Helper function to calculate distance between two coordinates in kilometers (Haversine formula)
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  const distance = R * c; // Distance in km
  return distance;
};

// Utility function to filter coordinates based on criteria
export const filterCoordinates = (
  coords, 
  status, 
  tipoIstanza, 
  applyStatusFilter, 
  applyTipoIstanzaFilter, 
  applyProximityFilter,
  range,
  userCoords,
  useCustomCoords,
  customCoords,
  calculateDistance
) => {
  if (!coords.length) return [];
  
  return coords.filter(coord => {
    const org = coord.org_pointer;
    
    // Only apply filters that are active
    const statusMatch = !applyStatusFilter || org.stato === status;
    const tipoIstanzaMatch = !applyTipoIstanzaFilter || org.tipo_istanza === tipoIstanza;
    
    // Apply proximity filter if active and location is available
    let proximityMatch = true;
    if (applyProximityFilter) {
      // Determine which location source to use
      const referenceLocation = useCustomCoords && customCoords ? 
        customCoords : userCoords;
        
      if (referenceLocation) {
        const distance = calculateDistance(
          referenceLocation.latitude || referenceLocation.lat, 
          referenceLocation.longitude || referenceLocation.lng, 
          coord.latitude, 
          coord.longitude
        );
        proximityMatch = distance <= range;
      }
    }
    
    return org && statusMatch && tipoIstanzaMatch && proximityMatch;
  });
};

// Calculate statistics from coordinates
export const calculateStats = (orgCoords) => {
  if (!orgCoords || !orgCoords.length) {
    return {
      all: 0,
      attiva: 0,
      disattiva: 0,
      production: 0,
      demo: 0,
      free: 0
    };
  }
  
  return {
    all: orgCoords.length,
    attiva: orgCoords.filter(coord => coord.org_pointer.stato === "attiva").length,
    disattiva: orgCoords.filter(coord => coord.org_pointer.stato === "disattiva").length,
    production: orgCoords.filter(coord => coord.org_pointer.tipo_istanza === "production").length,
    demo: orgCoords.filter(coord => coord.org_pointer.tipo_istanza === "demo").length,
    free: orgCoords.filter(coord => coord.org_pointer.tipo_istanza === "free").length
  };
}; 